import type { ExternalRequestStatus, FormAccessMode, FormFieldType } from '@pm/schemas';
import { Badge, type BadgeTone } from '@pm/ui';

export const ACCESS_MODE_LABEL: Record<FormAccessMode, string> = {
  PUBLIC_URL: 'Link público',
  TOKEN_PROTECTED: 'Link com token',
  AUTHENTICATED_CLIENT: 'Autenticado',
};

export const ACCESS_MODE_HINT: Record<FormAccessMode, string> = {
  PUBLIC_URL: 'Qualquer pessoa com o link envia solicitações.',
  TOKEN_PROTECTED: 'Só quem tem o link com o token (gerado uma única vez) consegue abrir.',
  AUTHENTICATED_CLIENT:
    'Só usuários autenticados enviam, em nome de um contato. O portal do cliente usará este modo.',
};

export const FIELD_TYPE_LABEL: Record<FormFieldType, string> = {
  TEXT: 'Texto curto',
  TEXTAREA: 'Texto longo',
  NUMBER: 'Número',
  CURRENCY: 'Valor (R$)',
  DATE: 'Data',
  DATETIME: 'Data e hora',
  BOOLEAN: 'Sim/Não',
  SELECT: 'Seleção única',
  MULTISELECT: 'Seleção múltipla',
  URL: 'URL',
  EMAIL: 'E-mail',
  PHONE: 'Telefone',
};

export const REQUEST_STATUS_LABEL: Record<ExternalRequestStatus, string> = {
  NEW: 'Nova',
  TRIAGE: 'Em triagem',
  APPROVED: 'Aprovada',
  REJECTED: 'Rejeitada',
};

const REQUEST_STATUS_TONE: Record<ExternalRequestStatus, BadgeTone> = {
  NEW: 'accent',
  TRIAGE: 'warning',
  APPROVED: 'success',
  REJECTED: 'neutral',
};

export function RequestStatusBadge({ status }: { status: ExternalRequestStatus }) {
  return <Badge tone={REQUEST_STATUS_TONE[status]}>{REQUEST_STATUS_LABEL[status]}</Badge>;
}

export function AccessModeBadge({ mode }: { mode: FormAccessMode }) {
  return (
    <Badge
      tone={mode === 'PUBLIC_URL' ? 'info' : mode === 'TOKEN_PROTECTED' ? 'violet' : 'neutral'}
    >
      {ACCESS_MODE_LABEL[mode]}
    </Badge>
  );
}

/** URL pública absoluta do formulário (mesma origem do app; Caddy em prod). */
export function publicFormUrl(slug: string): string {
  return `${window.location.origin}/f/${slug}`;
}

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
